const ITEMS = ["Soup Party", "October 3, 2026", "One Quart for Tasting", "Take As Many As You Bring", "Label Every Ingredient"];

export const Marquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-body text-sm md:text-base font-semibold uppercase tracking-[0.35em] text-forest px-8">
            {item}
          </span>
          <span className="h-2 w-2 rounded-full bg-forest" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative border-y border-forest bg-[#C88F52] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
};
